import { ReactComponent as MetadataSet } from "./set-metadata.svg";
import { ReactComponent as MetadataCleared } from "./clear-metadata.svg";
import { ReactComponent as Transferred } from "./transfer-ownership.svg";
import { ReactComponent as Frozen } from "./freeze-asset.svg";
import { ReactComponent as Thawed } from "./thaw-asset.svg";
import { ReactComponent as Burned } from "./burn.svg";
import { ReactComponent as AttributeSet } from "./set-attribute.svg";
import { ReactComponent as AttributeCleared } from "./clear-attribute.svg";
import { ReactComponent as Issued } from "./mint.svg";
import { ReactComponent as ApprovedTransfer } from "./approve-transfer.svg";
import { ReactComponent as ApprovalCancelled } from "./cancel-approval.svg";
import { ReactComponent as ItemPriceSet } from "./price-set.svg";
import { ReactComponent as ItemPriceRemoved } from "./price-removed.svg";
import { ReactComponent as ItemBought } from "./bought.svg";

const icons = {
  Issued,
  Burned,
  Frozen,
  Thawed,
  MetadataSet,
  MetadataCleared,
  AttributeSet,
  AttributeCleared,
  Transferred,
  ApprovedTransfer,
  ApprovalCancelled,
  ItemPriceSet,
  ItemPriceRemoved,
  ItemBought,
};

export default icons;
